import request from '@/utils/request'

export function getInfo() {
  return request({
    url: '/api/zh-cn/developer-platform/user/get-info',
    method: 'get'
  })
}

export function operatingCredit(data) {
  return request({
    url: '/api/zh-cn/developer-platform/user/operating-credit',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/api/zh-cn/account/logout',
    method: 'post'
  })
}
